import classNames from "classnames";
import { debounce } from "lodash";
import CloseIcon from "PFIcons/close.svg";
import SearchFatIcon from "PFIcons/search_fat.svg";
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import css from "./search.less";

const DEBOUNCE_TIME = 1500;

const Search = forwardRef(({ term, onTermChange, handleFocus, handleBlur }, ref) => {
  const { t } = useTranslation("auditPlanner");
  const onChange = useCallback(
    debounce((e) => onTermChange(e.target.value), DEBOUNCE_TIME),
    []
  );
  const handleClear = useCallback(() => onTermChange(""), []);

  return (
    <div className={css.search}>
      <div className={css.searchInputWrapper}>
        <div className={classNames(css.searchInput)}>
          <SearchFatIcon width={20} height={20} style={{ marginRight: 5 }} />
          <input
            ref={ref}
            onChange={onChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            placeholder={t("parts.searchEngagement")}
            defaultValue={term || ""}
          />
          <button className={css.clear} onClick={handleClear}>
            <CloseIcon width={20} height={20} />
          </button>
        </div>
      </div>
    </div>
  );
});

Search.displayName = "Search";

Search.propTypes = {
  term: PropTypes.string,
  onTermChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  handleFocus: PropTypes.func
};

export default Search;
